/**
 * Gets session value from cache
 * @param {string} id - The session id
 * @param {string} key - The value key
 * @returns {string}
 */
export function getSessionValue(id, key) {
  const CACHE_ROOT = 'TD_CACHE'
  const cache = localStorage.getItem(CACHE_ROOT)

  if (!cache) {
    return ''
  }

  const data = /** @type {TdSessionCacheData} */ (JSON.parse(cache))

  const sessionKey = `TdSession@${id}`

  if (!data[sessionKey]) {
    return ''
  }

  return data[sessionKey][key] || ''
}
